import { canPlayUiSfx, playSfxFile, preloadUiSfx } from './audioSettings';

// Yumuşak, kısa tık (eski tekbutonses.mp3 sert ve uzundu).
const BUTTON_CLICK_SOUND = '/sounds/ui_tik_yumusak.wav';
const POINT_INCREASE_SOUND = '/sounds/puanartirmasesi.mp3';
const ARTI_BAS_SOUND = '/sounds/artibasmasesi.mp3';
const ENHANCE_SUCCESS_SOUND = '/sounds/basarili.mp3';
const ENHANCE_FAIL_SOUND = '/sounds/basarisiz.mp3';

// Giriş ve ana menü ekranlarında tıklama sesi çalınmaz.
const SILENT_CLICK_PATHS = new Set(['/', '/login', '/register', '/intro', '/game', '/character-selection', '/ability-type-selection']);

export function preloadButtonSounds() {
  preloadUiSfx([BUTTON_CLICK_SOUND, ENHANCE_SUCCESS_SOUND, ENHANCE_FAIL_SOUND]);
}

/** UI buton tıklama sesi (dosya yoksa sessiz). */
export function playButtonClickSound(volume = 0.45) {
  playSfxFile(BUTTON_CLICK_SOUND, volume, 'ui');
}

/** Gelişim ekranı stat / skill puanı artırma sesi. */
export function playPointIncreaseSound(volume = 0.7) {
  playSfxFile(POINT_INCREASE_SOUND, volume, 'ui');
}

/** Köy enhancement — Artı Bas sesi. */
export function playArtiBasSound(volume = 0.7) {
  playSfxFile(ARTI_BAS_SOUND, volume, 'ui');
}

/** Enhancement başarılı (+1). */
export function playEnhanceSuccessSound(volume = 0.75) {
  playSfxFile(ENHANCE_SUCCESS_SOUND, volume, 'ui');
}

/** Enhancement başarısız (item yandı). */
export function playEnhanceFailSound(volume = 0.75) {
  playSfxFile(ENHANCE_FAIL_SOUND, volume, 'ui');
}

/** Craft başarılı: başarı sesi. */
export function playCraftSuccessSound(volume = 0.7) {
  playSfxFile(ENHANCE_SUCCESS_SOUND, volume, 'ui');
}

/** Craft başarısız: belirgin ama daha kısık başarısızlık sesi. */
export function playCraftFailSound(volume = 0.5) {
  playSfxFile(ENHANCE_FAIL_SOUND, volume, 'ui');
}

export function shouldPlayButtonClickSound(button, pathname) {
  if (!canPlayUiSfx()) return false;
  if (!button || button.disabled) return false;
  if (SILENT_CLICK_PATHS.has(pathname)) return false;
  if (button.getAttribute('data-silent-click') === 'true') return false;
  if (pathname === '/battle') {
    return Boolean(button.closest('.battle-nav-row'));
  }
  return true;
}
